import AdvanteIcons from './AdvanteIcons';
import IcoArrowThin from '../images/svg/IcoArrowThin';
import ServicesList from '../jsons/services.json'

import { Link } from 'react-router-dom';

const serviceBullets = {
  1: [
    'Bug fixes and small improvements',
    'Existing platform maintenance',
    'Human-reviewed AI development',
  ],
  2: [
    'Ticket scoping',
    'AI-assisted build',
    'QA and staging review',
  ],
  3: [
    'Safer code changes',
    'Cleaner workflows',
    'Better maintainability',
  ],
};

const sharedCapabilities = [
  'AI-assisted development',
  'Human QA',
  'Staging',
  'Pull requests',
  'Controlled deployment',
  'Stripe & payments',
  'Admin platforms',
  'Client portals',
];

const ServicesRoot = () => {
  const featuredServices = ServicesList.slice(0, 3);

  return (
    <section className='servicesRootWrapper ServicesRoot'>
      
      <div className='containerFull'>

          <h3>AI-assisted software delivery for existing platforms.</h3>
          <p className='servicesRoot-subtitle'>Experienced engineers plus a controlled AI delivery process that helps teams move faster without turning production into an experiment.</p>
      </div>

      <div className='services-fixed-grid'>
        {featuredServices.map((service) => (
          <article key={service.id} className='service-card-fixed'>
            <div className='service-card-overview'>
              <div className='service-icon'> 
                <AdvanteIcons
                  type={service.iconComponent}
                />
              </div>
              <h5>{service.name}</h5>
              <p>{service.description}</p> 
            </div>
            <div className='service-card-capabilities'>
              <ul className='service-bullets'>
                {(serviceBullets[service.id] || []).map((bullet) => (
                  <li key={bullet}>{bullet}</li>
                ))}
              </ul>
              <Link to={`/services/${service.url}`} className='see-more-btn absolute-right-bottom'>
                <span>See more</span> 
                <IcoArrowThin color='var(--tangerine-orange)' />
              </Link>
            </div>
          </article> 
        ))}
      </div>

      <div className='services-shared-capabilities'>
        {sharedCapabilities.map((capability) => (
          <span key={capability}>{capability}</span>
        ))}
      </div>
    </section>

  );
}


export default ServicesRoot;